import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0182ad', // From WordPress theme.json
        },
        secondary: {
            main: '#dfc113', // From WordPress theme.json
        },
        tertiary: {
            main: '#08a889', // From WordPress theme.json
        },
        background: {
            default: '#fafaf9', // Base color from theme.json
            paper: '#ffffff',
        },
        text: {
            primary: '#44403c', // Contrast color from theme.json
            secondary: '#1c1917', // Header foreground color
        },
        header: {
            background: '#0182ad',
            foreground: '#1c1917',
        }
    },
    typography: {
        fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 600,
            fontSize: '2.5rem',
        },
        h2: {
            fontWeight: 600,
            fontSize: '2rem',
        },
        h3: {
            fontWeight: 600,
            fontSize: '1.75rem',
        },
        h4: {
            fontWeight: 600,
            fontSize: '1.5rem',
        },
        h5: {
            fontWeight: 600,
            fontSize: '1.25rem',
        },
        h6: {
            fontWeight: 600,
            fontSize: '1rem',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    textTransform: 'none',
                    fontWeight: 500,
                },
                containedPrimary: {
                    backgroundColor: '#0182ad',
                    '&:hover': {
                        backgroundColor: '#C7AE6A',
                    },
                },
                containedSecondary: {
                    backgroundColor: '#dfc113',
                    '&:hover': {
                        backgroundColor: '#b39c10',
                    },
                },
            },
        },
        // Add MuiContainer override to remove max-width constraint
        MuiContainer: {
            styleOverrides: {
                root: {
                    '@media (min-width: 1200px)': {
                        maxWidth: 'none',
                    },
                },
            },
        },
    },
});

export default theme;